module.exports = __webpack_public_path__ + "img/V93.89efb2c8.jpg";